// extracted by mini-css-extract-plugin
module.exports = {"card":"ContactCard_card__xQ0vx"};